import { prActions } from '@/mocks/home';

const effectMeta: Record<string, string> = {
  正面: 'bg-primary-100 text-primary-800',
  负面: 'bg-accent-100 text-accent-900',
  中性: 'bg-secondary-100 text-secondary-900',
};

export default function PrActions() {
  return (
    <section id="pr" className="py-16 md:py-28">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">PR WATCH</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
              公关动作监测
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-sm leading-relaxed">
            声明、花絮、沉默……每一次动作都会改变风向。我们把动作和它对站队情况的实际影响放在一起看。
          </p>
        </div>

        <div className="border border-background-200/70 rounded-lg overflow-hidden">
          {prActions.map((action, index) => (
            <div
              key={action.title}
              className={`flex flex-col md:flex-row md:items-center gap-3 md:gap-6 px-4 md:px-6 py-5 ${
                index % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
              } ${index !== prActions.length - 1 ? 'border-b border-background-200/70' : ''}`}
            >
              <div className="flex items-center gap-3 md:w-52 shrink-0">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className={`${action.icon} text-lg`} />
                </span>
                <span className="font-label text-xs text-foreground-500">{action.time}</span>
              </div>

              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-background-200 text-foreground-700 font-label">
                    {action.type}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mt-2">
                  {action.title}
                </h3>
              </div>

              <div className="flex items-center gap-3 md:w-56 shrink-0 md:justify-end">
                <span className={`px-2 py-0.5 rounded-full text-xs font-label ${effectMeta[action.effect]}`}>
                  {action.effect}
                </span>
                <span className="text-xs text-foreground-500">{action.effectNote}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}